import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NamedloginComponent } from './namedlogin/namedlogin.component';
import { ChangeAccountPasswordComponent } from './change-account-password/change-account-password.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { KioskloginComponent } from './kiosklogin/kiosklogin.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'namedlogin',
    component: NamedloginComponent,
  },
  {
    path: 'resetaccountpassword',
    component: ChangeAccountPasswordComponent,
  },
  {
    path: 'smlogin',
    component: LoginComponent,
  },
  {
    path: 'kiosklogin',
    component: KioskloginComponent,
  },
  {
    path: 'createaccount',
    component: CreateAccountComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
